import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

export default function useDebounceSearch(
	key = 'name',
	initialValue,
	milliSeconds
) {
	const [debouncedValue, setDebouncedValue] = useState(initialValue);
	const [searchParams, setSearchParams] = useSearchParams();

	useEffect(() => {
		if (key && searchParams.get(key)) {
			setDebouncedValue(searchParams.get(key));
		}
	}, [searchParams]);

	useEffect(() => {
		const handler = setTimeout(() => {
			// Manzilni HOZIRGI holatidan o'qiymiz, effekt closure'idagi
			// `searchParams` dan emas.
			//
			// Nega: bu effekt faqat [debouncedValue] o'zgarganda qayta
			// yaratiladi, ya'ni odatda komponent yuklanganidagi nusxani
			// ushlab qoladi. Eski nusxani butunligicha manzilga qaytarib
			// yozish — oradan boshqa komponent qo'ygan parametrlarni
			// o'chirib yuborardi (masalan saqlangan filtrlar tiklangach,
			// 300 ms dan keyin ular yo'qolib ketardi).
			const next = new URLSearchParams(window.location.search);
			const current = next.get(key);

			if (debouncedValue) {
				// O'zgarish bo'lmasa — manzilga umuman tegmaymiz
				if (current === debouncedValue) return;

				next.set(key, debouncedValue);
				if (next.get('page')) {
					next.set('page', 1);
				}
			} else {
				// O'chiradigan narsa bo'lmasa — tegmaymiz. Shu sabab
				// komponent yuklanganda manzil bekorga qayta yozilmaydi.
				if (current === null) return;

				next.delete(key);
			}

			setSearchParams(next);
		}, milliSeconds);

		return () => {
			clearTimeout(handler);
		};
	}, [debouncedValue]);

	return [debouncedValue, setDebouncedValue];
}
